// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M18 10.5V7C18 3.68629 15.3137 1 12 1C8.68629 1 6 3.68629 6 7V10.5H3.5V22H12.4365C11.8409 20.9704 11.5 19.775 11.5 18.5C11.5 14.634 14.634 11.5 18.5 11.5C19.195 11.5 19.8663 11.6013 20.5 11.7899V10.5H18ZM12 3C14.2091 3 16 4.79086 16 7V10.5H8V7C8 4.79086 9.79086 3 12 3Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 18.5C13 15.4624 15.4624 13 18.5 13C21.5376 13 24 15.4624 24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5ZM20.9142 19.5001L19.5 18.0857V16.252H17.5V18.9141L19.4999 20.9142L20.9142 19.5001Z"}}]};

const LockTimeFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'lock-time-filled',
    ref,
    icon: element,
  },
));

LockTimeFilledIcon.displayName = 'LockTimeFilledIcon';

export default LockTimeFilledIcon;
